import { ANCHOR_IDS } from '~/lib/constants'

const LEAD_FORM_LINK_SELECTOR = `a[href*="#${ANCHOR_IDS.FEATURE_CREDIT_FORM_REQUEST}"]`

export default defineNuxtPlugin(() => {
  const { user } = useUser()
  const { trackEvent, setUserId } = useAnalytics()

  watch(
    () => user.value?.id ?? null,
    (userId) => setUserId(userId),
    { immediate: true }
  )

  // Phone links and links to the lead form are spread over many widgets and Revive
  // banners, so clicks on them are caught in one place
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return

    const phoneLink = event.target.closest<HTMLAnchorElement>('a[href^="tel:"]')
    if (phoneLink) {
      trackEvent('phone_click', { link_url: phoneLink.href })
      return
    }

    const leadFormLink = event.target.closest<HTMLAnchorElement>(LEAD_FORM_LINK_SELECTOR)
    if (leadFormLink) {
      // A link can name its own placement, e.g. the AI chat cards (`ai_chat`)
      trackEvent('lead_cta_click', {
        cta_location: leadFormLink.dataset.ctaLocation ?? 'form_link'
      })
    }
  })
})
